import { Injectable } from '@angular/core';
import { legalUrlServices } from '../services/legalServiceUrls';
import { HttpServiceService } from 'src/app/common-service/http-service.service';
import { data } from 'jquery';

@Injectable({
  providedIn: 'root'
})
export class LegalServicesService {
  
    constructor(public http: HttpServiceService, public url: legalUrlServices) { }

    // findAllColleges
  findAllColleges() {
    return this.http.get(this.url.getAllColleges);
  }
  
  //getAllUinversity
  findAllUniversity() {
    return this.http.get(this.url.getAllUniversity);
  }

  // findAllCourts
  findAllCourts() {
    return this.http.get(this.url.getAllCourts);
  }

  // findAllCourtsBench
  findAllCourtsBench(courtBeach: any) {
    return this.http.get(this.url.getAllCourtsBench + '?courtBeach=' + courtBeach);
  }

  // findAllCourts
  findAllLegalBankMstr() {
    return this.http.get(this.url.findAllLegalBankMstr);
  }

//  getAdvocateByCourtId
 getAdvocateByCourtId(courtId: any) {
  return this.http.get(this.url.getAdvocateByCourtId + '?courtId=' + courtId);
}
selectAdvocateListByFileNo(fileNo: any) {
  return this.http.get(this.url.selectAdvocateListByFileNo + '?fileNo=' + fileNo);
}
GetLegalAdvocateCommunication(advocateCommunicationId: any) {
  return this.http.get(this.url.GetLegalAdvocateCommunication + '?advocateCommunicationId=' + advocateCommunicationId);
}

getAdvocateByFileNo(fileNo: any) {
  return this.http.get(this.url.getAdvocateByFileNo + '?fileNo=' + fileNo);
}

findContentByFileNo(fileNo: any) {
  return this.http.get(this.url.findContentByFileNo + '?fileno=' + fileNo);
}

findCourtByFileNo(fileNo: any) {
  return this.http.get(this.url.findCourtByFileNo + '?fileNo=' + fileNo);
}

findCounterByFile(fileNo: any) {
  return this.http.get(this.url.findCounterByFile + '?fileNo=' + fileNo);
}

findAssignByFile(fileNo: any) {
  return this.http.get(this.url.findAssignByFile + '?fileNo=' + fileNo);
}

getAllLegalStatus()
{
return this.http.get(this.url.getAllLegalStatus);
}

getcourtId(fileNo: any) {
  return this.http.get(this.url.getcourtId + '?fileNo=' + fileNo);
}

  getAllCourtsBench() {
    return this.http.get(this.url.findAllCourtsBench);
  }

  findAllCourtsType() {
    return this.http.get(this.url.findAllCourtsType);
  }

  // findAllCaseType
  findAllCaseType() {
    return this.http.get(this.url.getAllCaseType);
  }

  // findAllCaseCategory
  findAllCaseCategory() {
    return this.http.get(this.url.getAllCaseCategory);
  }

// getAllCourts
findAllAdvocate(){
  return this.http.get(this.url.getAllAdvocateList);
}

getAllAdvocateCategory(){
  return this.http.get(this.url.getAllAdvocateCategory);
}
   // createNewCase
   createNewCase(legalCaseDetails: any) {    
    return this.http.post(this.url.createNewCase, legalCaseDetails);
  }  
   // createNewCase
   smilarCaseSave(legalCaseDetails: any) {    
    return this.http.post(this.url.smilarCaseSave, legalCaseDetails);
  }  


 // fileUploadsCreateNewCase
   fileUploadsCreateNewCase(filearray: any,filearray2: any,filearray3: any,filearray4: any,filearray5: any, fileNo: any,deleteLegalDocumentsList: any) {
    const formdata: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      formdata.append('file', filearray[i]);
    }
    for (let i = 0; i < filearray2.length; i++) {
      formdata.append('file1', filearray2[i]);
    }
    for (let i = 0; i < filearray3.length; i++) {
      formdata.append('file2', filearray3[i]);
    }
    for (let i = 0; i < filearray4.length; i++) {
      formdata.append('file3', filearray4[i]);
    }
    for (let i = 0; i < filearray5.length; i++) {
      formdata.append('file4', filearray5[i]);
    }
    for (let i = 0; i < deleteLegalDocumentsList.length; i++) {
      formdata.append('deleteLegalDocumentsList', deleteLegalDocumentsList[i]);
    }
    formdata.append('fileNo', JSON.stringify(fileNo));
    return this.http.post(this.url.fileUploadsCreateNewCase, formdata);

  }  


caseFileDetailsById(caseFileId : number){
      return this.http.get(this.url.caseFileDetailsById + '?Fileno=' + caseFileId);
}

findTaggedCasesByCourt(courtId : number){
  return this.http.get(this.url.findTaggedCasesByCourt + '?courtId=' + courtId);
}

findLeadCaseByCourt(courtId : number){
  return this.http.get(this.url.findLeadCaseByCourt + '?courtId=' + courtId);
}

//getAllLegalCaseDetailsWithPagination
getAllLegalCaseDetailsWithPagination(legalCaseDetailsSearchCriteria:any) {
    return this.http.post(this.url.getAllLegalCaseDetailsWithPagination ,legalCaseDetailsSearchCriteria);
  }

//getQueriesReportAddSearchCriteriaWithPagination
getQueriesReportAddSearchCriteriaWithPagination(queriesReportAddSearchCriteria:any) {
  return this.http.post(this.url.getQueriesReportAddSearchCriteriaWithPagination ,queriesReportAddSearchCriteria);
}

//queriesReportPDF
queriesReportPDF( queriesReportAddSearchCriteria:any ) {
  return this.http.post(this.url.queriesReportPDF,queriesReportAddSearchCriteria);
}

//exportStudentExcel
queriesReportExcel(queriesReportAddSearchCriteria: any) {
  return this.http.post(this.url.queriesReportExcel, queriesReportAddSearchCriteria);
}

  getAllLegalCaseDetails() {
    return this.http.get(this.url.getAllLegalCaseDetails);
  }
  // findAllTrustSociety
  findAllTrustSociety() {
    return this.http.get(this.url.getAllTrustSociety);
  }


  submitAdvocateCourtMappingDetails(legalAdvocateMapping:any){
    return this.http.post(this.url.submitAdvocateCourtMappingDetails,legalAdvocateMapping);
  }

  getAdvocateCourtMapping(advocateCourtMappingSearchCriteria : any) {
  
    return this.http.post(this.url.getAdvocateCourtMapping,advocateCourtMappingSearchCriteria);
  }
  
  // deleteAdvocateCourtMappingDetails(courtListName:any,courtBeach:any,checkedIDs:any, advocateCourtMappingId:any ){
  //   return this.http.get(this.url.deleteAdvocateCourtMappingDetails + '?courtName=' + courtListName + '&courtBeach=' + courtBeach + '&selectedItemsList=' + checkedIDs + '&advocateCourtMappingId=' + advocateCourtMappingId);
  // }

  getCaseToDoListMapping(caseToDoListMappingSearchCriteria : any) {
  
    return this.http.post(this.url.getCaseToDoListMapping,caseToDoListMappingSearchCriteria);
  }
  

  // Get Module Name
  getLegalCaseList(pageId: number, rowId: number) {
    return this.http.get(this.url.legalCaseList + '?page=' + pageId + '&rows=' + rowId);
  }

  //filepattern with pagination
  getFilePatternPagination(fileMasterSearchCriteria : any) {
    return this.http.post(this.url.getFilePatternPagination, fileMasterSearchCriteria);
  }
  
  // findAllColleges
  findMaxFileNo() {
    return this.http.get(this.url.getMaxFileNo);
  }
  getFileList(){
    return this.http.get(this.url.legalCaseList);
  }
  getAllCaseTaggingList(courtId:number){
    return this.http.get(this.url.getAllCaseTaggingList+ '?courtId=' + courtId );
  }

  getAllLeadCaseFile()
  {
    return this.http.get(this.url.getAllLeadCaseFile);

  }

  findAdvocateByUserMaster(advocateId:number){
    return this.http.get(this.url.findAdvocateByUserMaster+ '?advocateId=' + advocateId);
  }

  

//For Edit add by gokul
  getAllCaseTaggingDetailsById(taggingConnectivityMappingSaveId :number){
    return this.http.get(this.url.getAllCaseTaggingDetailsById+ '?taggingConnectivityMappingSaveId=' + taggingConnectivityMappingSaveId);
  }

  getAllCaseTaggedListss(courtId:number){
    return this.http.get(this.url.getAllCaseTaggedList+ '?courtId=' + courtId );
  }
  getCaseToDoList(){
    return this.http.get(this.url.getCaseToDoList);
  }
  getDashboard(){
    return this.http.get(this.url.getDashboard);
  }
  saveToDoList(data:any){
    return this.http.post(this.url.saveToDoList, data);
  }
  courtMasterSubmit(data:any){
    return this.http.post(this.url.courtMasterSubmit, data);
  }
  fileMasterSubmit(data:any){
    return this.http.post(this.url.fileMasterSubmit, data);
  }

  submitDetails(data:any){
    return this.http.post(this.url.submitDetails+'?courtType='+data,'');
  }

  submitCourtDetails(data:any){
    return this.http.post(this.url.submitCourtDetails+'?courtBenchType='+data,'');
  }

  getAdvocateMasterListWithPagination(pageId: number, rowId: number,advocateCategory:any, advocateName:any) {
  
    return this.http.get(this.url.getAdvocateMasterListWithPagination + '?page=' + pageId + '&rows=' + rowId + '&advocateCategory=' + advocateCategory + '&advocateName=' + advocateName);
  } 


  getCourtMasterListWithPagination(pageId: number, rowId: number,courtName:any) {
    return this.http.get(this.url.getCourtMasterListWithPagination + '?page=' + pageId + '&rows=' + rowId + '&courtName=' + courtName);
  }

  
  saveCaseToDoList(data:any){
    return this.http.post(this.url.saveCaseToDoList+'?caseList='+data,'');
  }

  submitToDoList(data:any){
    return this.http.post(this.url.submitToDoList,data);
  }

  submitCounter(data:any){
    return this.http.post(this.url.submitCounter,data);
  }

  saveAdvocateFeeList(obj){ 
    const formdata: FormData = new FormData();
    
    formdata.append('advocateFeeMasterJson', JSON.stringify(obj));
    return this.http.post(this.url.saveAdvocateFeeList, formdata);
  }

  submitCaseType(data:any,data1:any,data2:any){ 
    const obj ={
      caseTypeName:data,
      shortName:data1,
      caseTypeId:data2
    }
    return this.http.post(this.url.submitCaseType, obj);
  }

  submitCaseCategory(data:any,data2:any){
    return this.http.post(this.url.submitCaseCategory+'?categoryName='+data+'&caseCategoryId='+data2,'');
  } 

  saveAdvocateCategory(data:any,data2:any){
    return this.http.post(this.url.saveAdvocateCategory+'?advocateCategoryName='+data +'&advocateCategoryId='+data2,'');
  }

  getallsavedAdvocatelist(court:any){
    return this.http.post(this.url.getallsavedAdvocatelist, court);
  }
  GetLegalAdvocateMapping(legalAdvocateMappingId:any){
    return this.http.get(this.url.GetLegalAdvocateMapping+'?legalAdvocateMappingId='+legalAdvocateMappingId);
  }
  GetLegalAdvocateListByCourt(court:any){
    return this.http.get(this.url.GetLegalAdvocateListByCourt+'?legalcourtId='+court);
  }
  findAllAdvocateList(){
    return this.http.get(this.url.findAllAdvocateList);
  }
  courtBasedAdvocateList(courtId: any){
    return this.http.get(this.url.courtBasedAdvocateList+ '?courtId=' + courtId);
  }
  getallsavedTagginglist(courtListName:any){
    return this.http.get(this.url.getallsavedTagginglist + '?courtName=' + courtListName);
  }
  getCategoryByAdvocate(advocateId:any){
    return this.http.get(this.url.getCategoryByAdvocate + '?advocateId=' + advocateId);
  }

  getCalls(data: any,pageid:any,rowid:any) {
   
      return this.http.get(this.url.getAllAdvocate +'?page='+pageid+'&rows='+rowid);
  }

  getAdvocateCommunicationWithPagination(dciAdvocateCommunicationSearchCriteria:any)
  {
    return this.http.post(this.url.getAdvocateCommunicationWithPagination,dciAdvocateCommunicationSearchCriteria);

    
  }
  GetLegalAdvocateCommunicationSearchList(legalAdvocateCommunicationSearchCriteria:any)
  {
    return this.http.post(this.url.GetLegalAdvocateCommunicationSearchList,legalAdvocateCommunicationSearchCriteria);

    
  }
  getAdvocateInvoiceWithPagination( advocateInvoiceSearchCriteria :any)
  {
    return this.http.post(this.url.getAdvocateInvoiceWithPagination, advocateInvoiceSearchCriteria);

  }

  submitTaggingConnectedCase(data:any){
    return this.http.post(this.url.submitTaggingConnectedCase,data);
  }

  submitQueriesReport(obj: any,filearray: any){
    var formdata: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      formdata.append('file', filearray[i]);
    }
    formdata.append('legalQueriesReportsJson', JSON.stringify(obj));
    return this.http.post(this.url.submitQueriesReports, formdata);
    // return this.http.post(this.url.submitQueriesReports,data);
  }
  getTaggingConnectedCase( taggingConnectedSearchCriteria:any)
  {
    return this.http.post(this.url.getTaggingConnectedCase,taggingConnectedSearchCriteria);

  }

  submitTaggingConnectMappingDetails(taggingConnectivityMappingSave:any){
    return this.http.post(this.url.submitTaggingConnectMappingDetails, taggingConnectivityMappingSave);
  }
// getAllCourt
getAllCourtWithPage(pageId: number, rowId: number) {
  
  return this.http.get(this.url.getAllCourtWithPage + '?page=' + pageId + '&rows=' + rowId);
}

 // getAdvocateCategory

 getAdvocateCategory(advocateCategoryCriteria : any) { 
  
  return this.http.post(this.url.getAdvocateCategory, advocateCategoryCriteria);
}

findAllAdvocateCategory() {
  
  return this.http.get(this.url.findAllAdvocateCategory);
}

// getAdvocatemaster

getAdvocateMaster(pageId: number, rowId: number) {
  
  return this.http.get(this.url.getAdvocateMaster + '?page=' + pageId + '&rows=' + rowId);
}

 // getAssignAdvocateCategory

 getAssignAdvocateCategory(assignAdvocateCategoryPagSearchCriteria : any) {
  
  return this.http.post(this.url.getAssignAdvocateCategory, assignAdvocateCategoryPagSearchCriteria);
}

// getCaseCategoryMaster
getCaseCategoryMaster(caseCategorySearchCriteria:any) {
  
  return this.http.post(this.url.getCaseCategoryMaster,caseCategorySearchCriteria);
}

// getCounterReplyAffavadavit
getCounterReplyAffavadavit(counterReplySearchCriteria : any){
  
  return this.http.post(this.url.getCounterReplyAffavadavit,counterReplySearchCriteria);
}

//getChangeAdvocate

getChangeAdvocate(changeAdvocateSearchCriteria : any){
  
  return this.http.post(this.url.getChangeAdvocate,changeAdvocateSearchCriteria);
}

//getFileMaster

getFileMasterWithPage(pageId: number, rowId: number) {
  
  return this.http.get(this.url.getFileMasterWithPage + '?page=' + pageId + '&rows=' + rowId);
}

//gerDocumentTemplateMaster

getDocumentTemplateMasterWithPage(documentTemplateSearchCriteria:any) {
  return this.http.post(this.url.getDocumentTemplateMasterWithPage,documentTemplateSearchCriteria);
}

//getCaseToDoListMaster

getCaseToDoListMasterWithPage(caseToDoListMasterSearchCriteria : any) {
  
  return this.http.post(this.url.getCaseToDoListMasterWithPage, caseToDoListMasterSearchCriteria);
}

//getCaseFileManagement

getCaseFileManagementWithPage(caseFileManagementSearchCriteria: any) {
  
  return this.http.get(this.url.getCaseFileManagementWithPage,caseFileManagementSearchCriteria);
}

//getDocumentRepository

getDocumentRepositoryWithPage(documentRepositorySearchCriteria: any) {
  
  return this.http.post(this.url.getDocumentRepositoryWithPage,documentRepositorySearchCriteria);
}

//getDocuRepCategory
getDocuRepCategory()
{
return this.http.get(this.url.getDocuRepCategory);
}

//getDocuRepCategory
getDocuRepFileName()
{
return this.http.get(this.url.getDocuRepFileName);
}

//getAdvocateFeeMaster

getAdvocateFeeMaster(advocateFeeSearchCriteria : any) {
  return this.http.post(this.url.getAdvocateFeeMaster, advocateFeeSearchCriteria);
}

  submitQueriesReports(data:any){
    return this.http.post(this.url.submitQueriesReports,data);
  }
  getQueriesReports(quriesReportsSearchCriteria:any)
  {
  return this.http.post(this.url.getQueriesReports, quriesReportsSearchCriteria);
  }

  // submitDocumentRep(data:any,files:any){
  //   return this.http.post(this.url.submitDocumentRep,data);
  // }

   submitDocumentRep(obj,file:any) {
   // return this.http.post(this.url.createUserLegal, obj);

   const formdata: FormData = new FormData();
    for (let i = 0; i < file.length; i++) {
      formdata.append('file', file[i]);
    }
    formdata.append('submitDocumentRepMasterJson', JSON.stringify(obj));
    return this.http.post(this.url.submitDocumentRep, formdata);
  }

  saveAssign(data:any){
    return this.http.post(this.url.saveAssign,data);
  }
   // create User
   createUser(obj) {
    return this.http.post(this.url.createUser, obj);
  }

    // update user
    updateUser(obj) {
      return this.http.update(this.url.updateUser, obj);
    }

  createUserLegal(obj,file:any,file2:any) {
   // return this.http.post(this.url.createUserLegal, obj);

   const formdata: FormData = new FormData();
    for (let i = 0; i < file.length; i++) {
      formdata.append('bank', file[i]);
    }
    for (let i = 0; i < file2.length; i++) {
      formdata.append('loa', file2[i]);
    }
    formdata.append('advocateMasterJson', JSON.stringify(obj));
    return this.http.post(this.url.createUserLegal, formdata);
  }

  updateUserLegal(obj,file:any,file2:any) {
    // return this.http.post(this.url.createUserLegal, obj);
 
    const formdata: FormData = new FormData();
     for (let i = 0; i < file.length; i++) {
       formdata.append('bank', file[i]);
     }
     for (let i = 0; i < file2.length; i++) {
       formdata.append('loa', file2[i]);
     }
     formdata.append('advocateJson', JSON.stringify(obj));
     return this.http.post(this.url.updateUserLegal, formdata);
   }

  previewEditor(content:any){

    const formdata: FormData = new FormData();
    formdata.append('legalJson', JSON.stringify(content));
    return this.http.post(this.url.previewEditor,formdata);


      // return this.http.get(this.url.previewEditor +'?dispatchId='+dispatchId);

  }
  createCategoryLegal(obj,file:any) {
 
    const formdata: FormData = new FormData();
     for (let i = 0; i < file.length; i++) {
       formdata.append('file', file[i]);
     }
     formdata.append('caseCategoryMasterJson', JSON.stringify(obj));
     return this.http.post(this.url.createCategoryLegal, formdata);
   }
   
    // getCaseTypeMaster
    getCaseTypeMasterWithPage(caseTypeSearchCriteria:any) {
      return this.http.post(this.url.getCaseTypeMasterWithPage,caseTypeSearchCriteria);
    }

    saveDocumentTemplate(obj,file:any){
      const formdata: FormData = new FormData();
      for (let i = 0; i < file.length; i++) {
        formdata.append('file', file[i]);
      }
      
      formdata.append('documentTemplateMasterJson', JSON.stringify(obj));
      return this.http.post(this.url.saveDocumentTemplate, formdata);
    }
  
    submitCommunication(obj,file:any){
      const formdata: FormData = new FormData();
      for (let i = 0; i < file.length; i++) {
        formdata.append('file', file[i]);
      }
      formdata.append('communicationMasterJson', JSON.stringify(obj));
      return this.http.post(this.url.submitCommunication, formdata);
    }
    // SaveLegalAdvocateCommunication(objLegalAdvocateCommunication:any){ 
    // //   const formdata: FormData = new FormData();
    // //   for (let i = 0; i < file.length; i++) {
    // //     formdata.append('file', file[i]);
    // //   }
    // //   const blobOverrides = new Blob([JSON.stringify(objLegalAdvocateCommunication)], {
    // //     type: 'application/json',
    // //  });
    //   // formdata.append('body', new Blob([JSON.stringify(objLegalAdvocateCommunication)], {
    //   //   type: 'application/json'
    //   // }));
    //  // formdata.append('legalAdvocateCommunication',blobOverrides);
    //   return this.http.post(this.url.SaveLegalAdvocateCommunication, objLegalAdvocateCommunication);
    // }
    UploadLegalAdvocateCommunication(file:any,obj){
      const formdata: FormData = new FormData();
      for (let i = 0; i < file.length; i++) {
        formdata.append('file', file[i]);
      }
      formdata.append('legalAdvocateCommunicationId',obj);
      return this.http.post(this.url.UploadLegalAdvocateCommunication, formdata);
    }

    UploadAdvocateDashboardCommunication(file:any,obj){
      const formdata: FormData = new FormData();
      for (let i = 0; i < file.length; i++) {
        formdata.append('file', file[i]);
      }
      formdata.append('advocateDashboardCommunicationId',obj);
      return this.http.post(this.url.UploadAdvocateDashboardCommunication, formdata);
    }
    
    submitInvoice(obj,file:any){
      const formdata: FormData = new FormData();
      for (let i = 0; i < file.length; i++) {
        formdata.append('file', file[i]);
      }
      formdata.append('invoiceMasterJson', JSON.stringify(obj));
      return this.http.post(this.url.submitInvoice, formdata);
    }

    submitAdvocateInvoice(obj,file:any){
      const formdata: FormData = new FormData();
      for (let i = 0; i < file.length; i++) {
        formdata.append('file', file[i]);
      }
      formdata.append('invoiceMasterJson', JSON.stringify(obj));
      return this.http.post(this.url.submitAdvocateInvoice, formdata);
    }


    submitAdvocateDashboardCommunication(obj,file:any){
      const formdata: FormData = new FormData();
      for (let i = 0; i < file.length; i++) {
        formdata.append('file', file[i]);
      }
      formdata.append('communicationMasterJson', JSON.stringify(obj));
      return this.http.post(this.url.submitAdvocateDashboardCommunication, formdata);
    }
    
   
    saveChange(obj,file:any){
      const formdata: FormData = new FormData();
      for (let i = 0; i < file.length; i++) {
        formdata.append('file', file[i]);
      }
      formdata.append('changeAdvocateJson', JSON.stringify(obj));
      return this.http.post(this.url.saveChange, formdata);
    }

    courtMstrDetailsById(courtMstrId : number){
      return this.http.get(this.url.courtMstrDetailsById + '?courtMstrId=' + courtMstrId);
}
advocateCategoryDetailsById(advocateCategoryId : number){
  return this.http.get(this.url.advocateCategoryDetailsById + '?advocateCategoryId=' + advocateCategoryId);
}

caseCategoryDetailsById(caseCategoryId : number){
  return this.http.get(this.url.caseCategoryDetailsById + '?caseCategoryId=' + caseCategoryId);
}
caseCategoryDocumentDetailsById(caseCategoryId : number){
  return this.http.get(this.url.caseCategoryDocumentDetailsById + '?caseCategoryId=' + caseCategoryId);
}
caseTypeDetailsById(caseTypeId : number){
  return this.http.get(this.url.caseTypeDetailsById + '?caseTypeId=' + caseTypeId);
}

advocateFeeDetailsById(advocateFeeId : number){
  return this.http.get(this.url.advocateFeeDetailsById + '?advocateFeeId=' + advocateFeeId);
}

documentDetailsById(documentId : number){
  return this.http.get(this.url.documentDetailsById + '?documentId=' + documentId);
}

documentReposDetailsById(documentId : number){
  return this.http.get(this.url.documentReposDetailsById + '?documentId=' + documentId);
}

caseToDoListDetailsById(caseToDoListId : number){
  return this.http.get(this.url.caseToDoListDetailsById + '?caseToDoListId=' + caseToDoListId);
}

caseToDoListMappingDetailsById(caseToDoListMappingId : number){
  return this.http.get(this.url.caseToDoListMappingDetailsById + '?caseToDoListMappingId=' + caseToDoListMappingId);
}

filePatternDetailsById(filePatternId : number){
  return this.http.get(this.url.filePatternDetailsById + '?filePatternId=' + filePatternId);
}

advocateCommunicationDetailsById(advocateCommunicationId : number){
  return this.http.get(this.url.advocateCommunicationDetailsById + '?advocateCommunicationId=' + advocateCommunicationId);
}

advocateCommunicationDocumentDetailsById(advocateCommunicationId : number){
  return this.http.get(this.url.advocateCommunicationDocumentDetailsById + '?advocateCommunicationId=' + advocateCommunicationId);
}

deleteDocument(documentId : number){
  return this.http.get(this.url.deleteDocument + '?documentId=' + documentId);
}

deleteRepositoryDocument(documentId : number){
  return this.http.get(this.url.deleteRepositoryDocument + '?documentId=' + documentId);
}

deleteCommunicationDocument(documentId : number){
  return this.http.get(this.url.deleteCommunicationDocument + '?documentId=' + documentId);
}

deleteAdvocateDashboardCommunicationDocument(documentId : number){
  return this.http.get(this.url.deleteAdvocateDashboardCommunicationDocument + '?documentId=' + documentId);
}

documentTemplateDocumentDetailsById(documentId : number){
  return this.http.get(this.url.documentTemplateDocumentDetailsById + '?documentId=' + documentId);
}

documentRepositoryDetailsById(documentId : number){
  return this.http.get(this.url.documentRepositoryDetailsById + '?documentId=' + documentId);
}

advocateDetailsById(advocateId : number){
  return this.http.get(this.url.advocateDetailsById + '?advocateId=' + advocateId);
}
advocateDetailsByUserId(userId : number){
  return this.http.get(this.url.advocateDetailsByUserId + '?userId=' + userId);
}

advocateDocumentDetailsById(advocateId : number){
  return this.http.get(this.url.advocateDocumentDetailsById + '?advocateId=' + advocateId);
}

counterReplyDetailsById(counterReplyId : number){
  return this.http.get(this.url.counterReplyDetailsById + '?counterReplyId=' + counterReplyId);
}

invoiceDetailsById(invoiceId : number){
  return this.http.get(this.url.invoiceDetailsById + '?invoiceId=' + invoiceId);
}

invoiceDocumentDetailsById(invoiceId : number){
  return this.http.get(this.url.invoiceDocumentDetailsById + '?invoiceId=' + invoiceId);
}

assignAdvocateDetailsById(assignAdvocateId : number){
  return this.http.get(this.url.assignAdvocateDetailsById + '?assignAdvocateId=' + assignAdvocateId);
}

changeAdvocateDocumentDetailsById(assignAdvocateId : number){
  return this.http.get(this.url.changeAdvocateDocumentDetailsById + '?assignAdvocateId=' + assignAdvocateId);
}

deleteTemplateDocument(documentId : number){
  return this.http.get(this.url.deleteTemplateDocument + '?documentId=' + documentId);
}

deleteAdvocateDocument(advocateId : number){
  return this.http.get(this.url.deleteAdvocateDocument + '?advocateId=' + advocateId);
}

deleteInvoiceDocument(invoiceId : number){
  return this.http.get(this.url.deleteInvoiceDocument + '?invoiceId=' + invoiceId);
}


deleteAdvocateDashboardInvoiceDocument(advocateDashboardInvoiceId : number){
  return this.http.get(this.url.deleteAdvocateDashboardInvoiceDocument + '?advocateDashboardInvoiceId=' + advocateDashboardInvoiceId);
}

deleteAssignDocument(assignDocumentsId : number){
  return this.http.get(this.url.deleteAssignDocument + '?assignDocumentsId=' + assignDocumentsId);
}

filePatternSubmit(fileNoPattern : number){
  return this.http.post(this.url.filePatternSubmit + '?fileNoPattern=' + fileNoPattern,'');
}

// post
  agendaCreateforcaseFile(data: any) {
    return this.http.post(this.url.agendaCreation, data);
  }


courtsContantForCkEditor(fileNoId : number){
  return this.http.get(this.url.courtsContantForCkEditor + '?fileno=' + fileNoId);
}
  findContentByCourtId(courtId:any){
    return this.http.get(this.url.findContentByCourtId + '?courtId=' + courtId);

}

communicationContantForCkEditor(fileNoId : number){
  return this.http.get(this.url.communicationContantForCkEditor + '?fileno=' + fileNoId);
}

}




